import PropTypes from 'prop-types'
import React from 'react'
import useTranslation from 'next-translate/useTranslation'

export const ShowCounter = ({count}) => {
  const { t } = useTranslation('common')

  return (
    <p>{t('Broj pregleda oglasa')}: {count}</p>
  )
}

ShowCounter.propTypes = {
  count: PropTypes.number.isRequired
}

ShowCounter.defaultProps = {
  count: 0
}
